import { makeStyles } from "@material-ui/core";
const styles = makeStyles((theme) => ({
  footer: {
    height: "100%",
    background: "#FFFFFF",
    flexShrink: 0,
  },
  content: {
    padding: "1.875rem 0",
  },
  caption: {
    textTransform: 'uppercase'
  },
  navLink: {
    cursor: "pointer",
    fontWeight: "bold",
    textTransform: 'uppercase'
  },
}));
export default styles;
